<template>
  <div class="lawsuits-container">
<!-- Restriction Group -->
    <div class="lawsuit-group">
      <div :class="this.client.customerLikelyInDebt ? 'group-header-indebt' : 'group-header-not-indebt'" @click="toggleGroup('restrictions')">
        <h2 class="group-title-indebtness">
          <b>{{ client.customerLikelyInDebt ? 'Foram' : 'Não foram' }}</b> encontrados registros de negativação para <b>{{ client.name }}</b>!
        </h2>
        <i class="toggle-icon">
          {{ expandedGroups.restrictions ? 'mostrar menos' : 'mostrar mais' }}
        </i>
      </div>
      <transition name="fade">
        <div v-if="expandedGroups.restrictions" class="cards-wrapper">
            <div v-if="hasRestrictions">
              <div v-for="(restrictions, type) in filteredRestrictions" :key="type" class="restriction-type">
                <h3 class="restriction-type-title">{{ type }} </h3>
                <div v-for="restriction in restrictions" :key="restriction.CONTRATO" class="restriction-card">
                <!-- <div v-if="restriction.DATA_INCLUSAO != '' "> -->
                  <div class="card-header">
                        <div class="status-badge">Vencimento: {{ formatDateRestrictions(restriction.DATA_VENCIMENTO) }}</div>
                        <div class="value-display">R$ {{ restriction.VALOR }}</div>
                  </div>
                <!-- </div> -->
                    <!-- <div v-if="restriction.DATA_INCLUSAO != '' "> -->
                      <div class="card-body">
                        <div class="detail-section">
                          <div class="detail-row">
                            <span class="detail-label">Data Inclusão:</span>
                            <span>{{ formatDateRestrictions(restriction.DATA_INCLUSAO) }}</span>
                          </div>
                          <!-- <div class="detail-row">
                            <span class="detail-label">Informante:</span>
                            <span>{{ restriction.INFORMANTE }}</span>
                          </div> -->
                          <!-- <div class="detail-row">
                            <span class="detail-label">Tipo Devedor:</span>
                            <span>{{ restriction.TIPO_DEVEDOR }}</span>
                          </div> -->
                          <div class="detail-row">
                            <span class="detail-label">Credor:</span>
                            <span>{{ restriction.CREDOR }}</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">Valor:</span>
                            <span>{{ restriction.MOEDA + ' ' + restriction.VALOR}}</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">Contrato:</span>
                            <span>{{ restriction.CONTRATO }}</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">Origem:</span>
                            <span>{{ restriction.ORIGEM }}</span>
                          </div>
                          <!-- <div class="detail-row">
                            <span class="detail-label">Subjudice:</span>
                            <span>{{ restriction.SUBJUDICE || 'N/A' }}</span>
                          </div> -->
                          <div class="detail-row">
                            <span class="detail-label">Modalidade:</span>
                            <span>{{ restriction.MODALIDADE }}</span>
                          </div>
                          <!-- <div class="detail-row">
                            <span class="detail-label">Entidade:</span>
                            <span>{{ restriction.ENTIDADE || 'N/A' }}</span>
                          </div> -->
                        </div>
                      </div>
                    <!-- </div> -->
                </div>
            </div>
          </div>
          <div v-else class="no-restrictions">
            <p>Sem itens para exibição.</p>
          </div>
          <!-- <p class="no-restrictions">{{ client.iConsulteiQueryStatus ? '' : 'ATENÇÃO! Ocorreu um erro ao buscar negativações.' }}</p> -->
        </div>
      </transition>
    </div>

    <!-- Defendant Group -->
    <div class="lawsuit-group">
      <div class="group-header" @click="toggleGroup('defendant')">
        <h2 class="group-title">
          O cliente é réu em ({{ defendantLawsuits.length }}) {{ defendantLawsuits.length === 1 ? 'processo' : 'processos' }}
          <span v-if="defendantLawsuits.length === 0" class="empty-message">- Nenhum processo onde o cliente é réu</span>
        </h2>
        <i class="toggle-icon">
          {{ expandedGroups.defendant ? 'mostrar menos' : 'mostrar mais' }}
        </i>
      </div>
      
      <transition name="fade">
        <div v-if="expandedGroups.defendant" class="cards-wrapper">
          <div v-for="lawsuit in defendantLawsuits" :key="lawsuit.Number" 
               class="lawsuit-card">
            <div class="card-header">
              <div class="status-badge" :class="lawsuit.Status.toLowerCase()">
                {{ lawsuit.Type }} - {{ lawsuit.Status }}
              </div>
              <div class="value-display">
                R$ {{ formatCurrency(lawsuit.Value) }}
              </div>
            </div>

            <div class="card-body">
              <div class="case-meta">
                <h3 class="case-number">No. {{ lawsuit.Number }}</h3>
                <!-- <p class="case-type">{{ lawsuit.Type }}</p> -->
              </div>

              <div class="detail-section">
                <div class="detail-row">
                  <span class="detail-label">Tribunal:</span>
                  <span>{{ lawsuit.CourtName }} - {{ lawsuit.JudgingBody }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Objeto:</span>
                  <span>{{ lawsuit.MainSubject }}</span>
                </div>
                <!-- <div class="detail-row">
                  <span class="detail-label">Encerrado:</span>
                  <span>{{ formatDate(lawsuit.CloseDate) }}</span>
                </div> -->
              </div>

              <div class="parties-section">
                <h4>Partes envolvidas</h4>
                <div class="parties-grid">
                  <div v-for="party in lawsuit.Parties" :key="party.Doc" 
                       class="party-item" :class="party.Type.toLowerCase()">
                    <span class="party-name">{{ party.Name }}</span>
                    <span class="party-type">{{ translatePartyType(party.Type) }}</span>
                  </div>
                </div>
              </div>

              <div class="updates-section">
                <h4>Últimas atualizações</h4>
                <div v-for="(update, index) in lawsuit.Updates.slice(0, 3)" 
                     :key="index" class="update-item">
                  <div class="update-date">{{ formatDate(update.PublishDate) }}</div>
                  <div class="update-content">{{ truncateText(update.Content, 120) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>

    <!-- Author Group -->
    <div class="lawsuit-group">
      <div class="group-header" @click="toggleGroup('author')">
        <h2 class="group-title">
          O cliente moveu ({{ authorLawsuits.length }}) {{ authorLawsuits.length === 1 ? 'processo' : 'processos' }} contra terceiros
          <span v-if="authorLawsuits.length === 0" class="empty-message">- Nenhum processo foi movido pelo cliente</span>
        </h2>
        <i class="toggle-icon">
          {{ expandedGroups.author ? 'mostrar menos' : 'mostrar mais' }}
        </i>
      </div>
      
      <transition name="fade">
        <div v-if="expandedGroups.author" class="cards-wrapper">
          <div v-for="lawsuit in authorLawsuits" :key="lawsuit.Number" 
               class="lawsuit-card">
            <div class="card-header">
              <div class="status-badge" :class="lawsuit.Status.toLowerCase()">
                {{ lawsuit.Type }} - {{ lawsuit.Status }}
              </div>
              <div class="value-display">
                R$ {{ formatCurrency(lawsuit.Value) }}
              </div>
            </div>

            <div class="card-body">
              <div class="case-meta">
                <h3 class="case-number">No. {{ lawsuit.Number }}</h3>
                <!-- <p class="case-type">{{ lawsuit.Type }}</p> -->
              </div>

              <div class="detail-section">
                <div class="detail-row">
                  <span class="detail-label">Tribunal:</span>
                  <span>{{ lawsuit.CourtName }} - {{ lawsuit.JudgingBody }}</span>
                </div>
                <div class="detail-row">
                  <span class="detail-label">Objeto:</span>
                  <span>{{ lawsuit.MainSubject }}</span>
                </div>
                <!-- <div class="detail-row">
                  <span class="detail-label">Encerrado:</span>
                  <span>{{ formatDate(lawsuit.CloseDate) }}</span>
                </div> -->
              </div>

              <div class="parties-section">
                <h4>Partes envolvidas</h4>
                <div class="parties-grid">
                  <div v-for="party in lawsuit.Parties" :key="party.Doc" 
                       class="party-item" :class="party.Type.toLowerCase()">
                    <span class="party-name">{{ party.Name }}</span>
                    <span class="party-type">{{ translatePartyType(party.Type) }}</span>
                  </div>
                </div>
              </div>

              <div class="updates-section">
                <h4>Últimas atualizações</h4>
                <div v-for="(update, index) in lawsuit.Updates.slice(0, 3)" 
                     :key="index" class="update-item">
                  <div class="update-date">{{ formatDate(update.PublishDate) }}</div>
                  <div class="update-content">{{ truncateText(update.Content, 120) }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      expandedGroups: {
        defendant: true,
        author: true,
        restrictions: true
      },
      partyTypeTranslations: {
        'LAWYER': 'Advogado',
        'CLAIMANT': 'Reclamante',
        'CLAIMED': 'Reivindicado',
        'REPORTER': 'Relator',
        'OTHER': 'Outro',
        'REQTE': 'Requerente',
        'REQDO': 'Requerido',
        'EXEQTE': 'Exequente',
        'EXECTDA': 'Executado',
        'JUDGE': 'Juiz',
        'AUTHOR': 'Reclamante',
        'DEFENDANT': 'Réu',
        'PROSECUTOR': 'Promotor',
        'DEFENDED': 'Réu',
        'ATTORNEY': 'Advogado',
        // Add more translations as needed
      }
    };
  },
  
  props: {
    client: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters({
      storeID: types.AUTH_ACTIVE_STORE
    }),

  defendantLawsuits() {
  return this.client.customerProcesses.Result[0].Processes.Lawsuits.filter(lawsuit => {
    // Check if Parties exists and is an array
    if (!lawsuit.Parties || !Array.isArray(lawsuit.Parties)) {
      return false; // Skip lawsuits without valid Parties
    }
    // Check if any party has the client's document number and is a defendant
    return lawsuit.Parties.some(party => 
      party.Doc === this.client.customerProcesses.Result[0].MatchKeys.replace('doc', '').replace(/[{}]/g, '') &&
      party.Polarity === 'PASSIVE'
    );
  });
},
  authorLawsuits() {
  return this.client.customerProcesses.Result[0].Processes.Lawsuits.filter(lawsuit => {
    // Check if Parties exists and is an array
    if (!lawsuit.Parties || !Array.isArray(lawsuit.Parties)) {
      return false; // Skip lawsuits without valid Parties
    }
    // Check if any party has the client's document number and is a defendant
    return lawsuit.Parties.some(party => 
      party.Doc === this.client.customerProcesses.Result[0].MatchKeys.replace('doc', '').replace(/[{}]/g, '') &&
      party.Polarity === 'ACTIVE'
    );
  });
  },
  hasRestrictions() {
    return Object.values(this.client.customerRestrictions).some(arr => arr.length > 0);
  },
  filteredRestrictions() {
      return Object.fromEntries(
        Object.entries(this.client.customerRestrictions).filter(
          ([type, restrictions]) => restrictions.length > 0
        )
      );
    }
  },
  
  methods: {
    toggleGroup(group) {
      this.expandedGroups[group] = !this.expandedGroups[group]
    },
    formatCurrencyRestrictions(value) {
      const num = parseFloat(value.replace(',', '.'));
      return num.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    },
    formatCurrency(value) {
      return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 })
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString('pt-BR')
    },
    truncateText(text, maxLength) {
      return text.length > maxLength ? text.substr(0, maxLength) + '...' : text
    },
    translatePartyType(type) {
      return this.partyTypeTranslations[type] || type
    },
    parseDate(dateString) {
      if (!dateString) return null;
      const [day, month, year] = dateString.split('/');
      return new Date(year, month - 1, day);
    },
    formatDateRestrictions(dateString) {
      if (!dateString) return 'N/A';
      const date = this.parseDate(dateString);
      return date ? date.toLocaleDateString('pt-BR') : 'N/A';
    }
  }
};
</script>

<style scoped>
/* Import Montserrat font from Google Fonts with font-display swap */
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.restriction-type {
  margin-bottom: 20px;
}
.restriction-type-title {
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 12px;
}
.no-restrictions {
  text-align: center;
  padding: 16px;
  color: #6c757d;
}

.lawsuits-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, sans-serif;
}

.lawsuit-group {
  margin-bottom: 30px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f8f9fa;
  cursor: pointer;
  transition: background-color 0.2s;
}

.group-header-not-indebt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #b2f8c6;
  cursor: pointer;
  transition: background-color 0.2s;
}

.group-header-indebt {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  background: #f8b2b2;
  cursor: pointer;
  transition: background-color 0.2s;
}

.group-header:hover {
  background: #e9ecef;
}

.group-title {
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
}

.group-title-indebtness {
  margin: 0;
  font-size: 14px;
  color: #2c3e50;
  font-weight: 400;
}

.empty-message {
  font-weight: 400;
  color: #6c757d;
}

.toggle-icon {
  font-size: 10px;
  color: #6c757d;
  transition: transform 0.2s;
}

.cards-wrapper {
  padding: 16px;
}

.lawsuit-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  overflow: hidden;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: #f8f9fa;
}

.status-badge {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.arquivado {
  background: #e9ecef;
  color: #6c757d;
}

.status-badge.active {
  background: #d4edda;
  color: #155724;
}

.value-display {
  font-size: 16px;
  font-weight: 700;
  color: #ff5e44;
}

.card-body {
  padding: 16px;
}

.case-meta {
  margin-bottom: 16px;
}

.case-number {
  margin: 0 0 4px;
  font-size: 12px;
  color: #2c3e50;
  font-weight: 600;
}

.case-type {
  margin: 0;
  font-size: 12px;
  color: #6c757d;
  font-weight: 400;
}

.detail-section {
  margin-bottom: 16px;
}

.detail-row {
  display: flex;
  font-size: 12px;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid #e9ecef;
  font-weight: 500;
}

.detail-row:last-child {
  border-bottom: none;
}

.detail-label {
  font-size: 12px;
  font-weight: 500;
  color: #495057;
}

.parties-section h4,
.updates-section h4 {
  font-weight: 600;
  font-size: 12px;
  margin: 16px 0 8px;
  color: #2c3e50;
}

.parties-grid {
  display: grid;
  font-size: 12px;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 12px;
  margin-top: 8px;
}

.party-item {
  padding: 8px;
  font-size: 12px;
  border-radius: 6px;
  background: #f8f9fa;
}

.party-name {
  font-size: 12px;
  font-weight: 500;
  display: block;
}

.party-type {
  font-weight: 400;
  font-size: 12px;
  color: #6c757d;
}

.update-item {
  margin-top: 8px;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
}

.update-date {
  font-size: 12px;
  color: #6c757d;
  margin-bottom: 4px;
  font-weight: 400;
}

.update-content {
  font-size: 11px;
  font-weight: 400;
  line-height: 1.4;
}

/* Transition effects */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.card-list-move {
  transition: transform 0.3s;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .group-title {
    font-size: 13px;
  }

  .value-display {
    font-size: 13px;
  }

  .case-number {
    font-size: 13px;
  }

  .parties-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }
}

@media (max-width: 480px) {
  .lawsuit-card {
    margin-bottom: 12px;
  }

  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .status-badge {
    align-self: flex-start;
  }

  .parties-grid {
    grid-template-columns: 1fr;
  }
}
</style>